import React, { useEffect, useState } from "react";
import COLOR from "../../theme/colors";
import { useSelector } from "react-redux";
import {VerticalBarRepresentation} from "../../components/shared/charts/BarRepresentation";

const ProductCategories = ( {productCategoriesData} ) => {
    const {
        datapoints = [],
        title = "",
    } = productCategoriesData || {};
    const { productCategories } = useSelector((state) => state.categories);

    const [processedData, setProcessedData] = useState([]);
    useEffect(() => {
        const updated = datapoints.map(dp => {
            const match = productCategories.find(pc => pc.value === dp.value);
            return {
                ...dp,
                value: match ? match.label : dp.value,
            };
        });
        setProcessedData(updated);
    }, [datapoints, productCategories]);
    return (
        <VerticalBarRepresentation
            data={processedData}
            title={title}
            color={COLOR.AREA_CHART}
            xAxisDataKey="value"
            yAxisDataKey="count"
        />
    );
};

export default ProductCategories;
